import { AnchorHTMLAttributes, ReactNode } from "react";
import { trackDownloadClick, DownloadType, getDownloadUrl } from "@/utils/download";

interface DownloadLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  /** 下载类型，用于统计 */
  downloadType?: DownloadType;
  /** 子元素 */
  children: ReactNode;
  /** 是否在新窗口打开 */
  openInNewTab?: boolean;
}

/**
 * 下载链接组件
 * 自动处理 Facebook Pixel 统计
 */
export default function DownloadLink({
  downloadType = "link",
  children,
  openInNewTab = false,
  onClick,
  ...props
}: DownloadLinkProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // 触发下载点击统计
    trackDownloadClick(downloadType);

    // 调用原有的 onClick 处理函数
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <a
      href={getDownloadUrl()}
      target={openInNewTab ? "_blank" : undefined}
      rel={openInNewTab ? "noopener noreferrer" : undefined}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  );
}
